module.exports = __webpack_public_path__ + "img/checkout-vnpay-notsuccess.7c3705b.webp";